import { NavLink } from "@mantine/core";

import S from "./NavLink.module.css";

export const navLinkOverrides = {
  NavLink: NavLink.extend({
    defaultProps: {
      //@ts-expect-error - this does work, and we want to ensure that the role is set
      role: "link",
      // Mantine's default expand/collapse chevron (AccordionChevron) renders
      // a bare <svg> with no accessible name — it's purely decorative (the
      // same information is already conveyed by aria-expanded on the link
      // itself), so hide it from assistive tech instead of leaving it
      // unlabeled. Unlike classNames/styles/vars, `attributes` has no
      // dedicated theme-level resolver in Mantine's styles-api — it only
      // reaches the component via useProps's defaultProps merge, so it must
      // live here rather than as a sibling of defaultProps.
      attributes: {
        chevron: { "aria-hidden": true },
      },
    },
    classNames: {
      root: S.NavLink,
      label: S.NavLinkLabel,
      chevron: S.NavLinkChevron,
      section: S.NavLinkSection,
    },
  }),
};
